import {Component, Input} from '@angular/core';
import {AssetPropertyValue, AssetWithProperties} from "../../asset.model";
import {PropertyValue} from "../../../upload/upload.model";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-asset-detail-property',
    imports: [
        TranslatePipe
    ],
    templateUrl: './asset-detail-property.component.html',
    styleUrl: './asset-detail-property.component.scss'
})
export class AssetDetailPropertyComponent {

    @Input() name: string = '';
    @Input() value: AssetPropertyValue = '';

    protected readonly Array = Array;
}
